import * as firebase    from 'firebase/app';

function getProivder(str: string) {
    switch (str) {
        case 'google':
            return new firebase.auth.GoogleAuthProvider();
        case 'facebook':
            return new firebase.auth.FacebookAuthProvider();
        default:
            return new firebase.auth.GoogleAuthProvider();
    }
}

export default getProivder;
